export default __webpack_public_path__ + "static/media/35.1d11571c.jpeg";